<template>
	<div class="historytable">
		<vx-card title="企业文化考核详情">
			<div style="display: flex;justify-content: space-between;">
			<vs-breadcrumb :items="[{title: '历史数据',url: '/admin/history'},{title: '数据详情',active: true}]"></vs-breadcrumb>
			<router-link :to="{path:'/admin/historydetails',query:{id:id}}">
			<vs-button color="primary" type="filled">返回</vs-button>
			</router-link>
			</div>
		</vx-card>
		<div class="mytable m-4 flex p-4" style="background-color: #FFFFFF;flex-direction: column;">
				<div class="info">
					<div v-if="user">
						<p><em style="color: #000000;font-weight: 600;">提交人：</em>{{user.userName}}</p>
						<!-- <p><em style="color: #000000;font-weight: 600;">审核员：</em><el-tag class="mr-4" v-for="(item,idx) in user.reviewerTotalScore" :key="idx">{{item.name}}</el-tag></p> -->
						<p><em style="color: #000000;font-weight: 600;">自评总分：</em><span style="color: red;font-size: 16px;">{{grade}}</span></p>
					</div>
					<div>
						<el-button type="primary" @click="submitForm">保存</el-button>
					</div>
				</div>
				<div class="vx-col w-full  mb-base">
					<el-table
					  id="table3"
					  :header-cell-style="{background:'#7367F0',color:'#ffffff',fontSize:'14px'}"
					  border
					  :span-method="arraySpanMethod"
					  :data="table"
					  style="width: 100%">
					  <el-table-column
					    prop="dimension"
					    label="考核类"
						width="100">
						<template slot-scope="scope">
							<p v-if="scope.$index==0">顾客至上</p>
							<p v-if="scope.$index==5">团队精神</p>
							<p v-if="scope.$index==10">追求卓越</p>
							<p v-if="scope.$index==15">长期坚持艰苦奋斗</p>
						</template>
					  </el-table-column>
					  <el-table-column
					    prop="behaviors"
					    label="考核项"
					    width="180">
						<template slot-scope="scope">
						  <p>{{scope.$index+1}}.{{scope.row.behaviors}}
						  <el-tooltip class="item" effect="light"  placement="bottom-start">
							    <div slot="content">
									<p><span style="color: red;">行为标准:</span>{{scope.row.standards}}</p>
									<p><span style="color: red;">举证突出:</span>{{scope.row.prominentEvidence}}</p>
								</div>
						        <i class="el-icon-warning-outline"></i>
						  </el-tooltip>
						  </p>
						</template>
					  </el-table-column>
					  <!-- <el-table-column
					    prop="standards"
					    label="行为标准"
					    width="180">
					  </el-table-column>
					  <el-table-column
					    prop="prominentEvidence"
					    label="举证突出"
						width="200">
					  </el-table-column> -->
					  <el-table-column
					    prop="markingCriterion"
					    label="评分标准"
					    width="300">
					  </el-table-column>
					  <el-table-column
					    prop="evidence"
					    label="行为佐证"
						min-width="300">
					  </el-table-column>
					  <el-table-column
					    prop="evidenceSource"
					    label="佐证来源"
						width="120">
					  </el-table-column>
					  <el-table-column
					    prop="selfEvaluation"
					    label="自评分"
						width="70"
						align="center">
					  </el-table-column>
					  <el-table-column
					    prop="selfEvaluation"
						align="center"
						width="70"
					    :label="info[index][index].name"
						v-for="(item,index) in info[0]" :key="index">
						<template slot-scope="scope">
						  <p>{{info[scope.$index][index].leaderScore}}</p>
						</template>
					  </el-table-column>
					  <el-table-column
					    prop="remarks"
						width="220"
					    label="点评">
						<template slot-scope="scope">
						   <el-input type="textarea" v-model="scope.row.comment"  :autosize="{ minRows: 3, maxRows: 12}"></el-input>
						</template>
					  </el-table-column>
					  <!-- <el-table-column
					    prop="leaderScore"
					    label="我的评分">
					  	<template slot-scope="scope">
							<el-select v-model="scope.row.leaderScore" placeholder="请选择">
							    <el-option
							      v-for="item in scope.row.grade"
							      :key="item"
							      :label="item"
							      :value="item">
							    </el-option>
							</el-select>
					  	</template>
					  </el-table-column> -->
					</el-table>
				</div>
		</div>
		
	</div>
	
</template>
<script>
	export default {
	    data() {
	        return {
				user:'',
				id:'',
				info:[],
				grade:0,  //自评总分
				scored:'',
				table:[],
			}
				   
	    },
		watch:{
			table:{
				handler(newvalue,oldvalue) {
					this.getgrade();
				},
				deep: true
			}
		},
		mounted() {
			this.user=JSON.parse(localStorage.getItem("userdetails"));
			this.id=this.$route.query.id;
			this.getdetails();
		},
		methods: {
			arraySpanMethod({ row, column, rowIndex, columnIndex }){  //合并行与列
				if (columnIndex === 0) {
				        if (rowIndex % 5 === 0) {
				            return {
				              rowspan: 5,
				              colspan: 1
							};
						} else {
							return {
								  rowspan: 0,
								  colspan: 0
							};
						}
				}
			},
			submitForm(){     //保存标准
				const that = this;
				const arr=[];
				that.table.forEach(item=>{
					arr.push({id:item.id,staffAssessId:item.staffAssessId,comment:item.comment})
				})
				this.$api.inspacetor(arr,{'content-type':'application/json'}).then(function (response) {
					console.log("保存结果：",response);
					if(response.code==0){
						 that.$vs.notify({
							  title:"提示",
							  color:'success',
							  text:response.message,
							  position:'top-center'
						 });
						 that.getdetails();
					}else{
						that.$vs.notify({
							  title:"提示",
							  color:'warning',
							  text:response.message,
							  position:'top-center'
						});
					}
				})
			},
			getgrade(){			//计算自评总分
				var that=this;
				that.grade=0;
				for(var i=0;i<that.table.length;i++){
					that.grade=parseInt(that.grade)+parseInt(that.table[i].selfEvaluation);
				}
			},
			getdetails(){   //获取详情
				const that = this;
				that.table=[];
				this.$api.allscoredetails({id :that.id}).then(function (response) {
					console.log("详情2：",response);
					if(response.code==0){
						 response.data.forEach(i=>{
						 		i.templateInfoVo.forEach(t=>{
										t.grade=t.optionalScore?t.optionalScore.split(","):[];
										that.table.push(t)
						 				that.info.push(t.leaderScore);
						 		})
						 });
						 that.getgrade();
					}else{
						that.$vs.notify({
							  title:"提示",
							  color:'warning',
							  text:response.message,
							  position:'top-center'
						});
					}
				})
			},
		}   
	}
</script>
<style type="text/css">
	.mytable .info{
		height: 60px;
		line-height: 60px;
		display: flex;
		justify-content: space-between;
		padding: 0 20px;
		align-items: center;
	}
	.mytable .info p{
		font-size: 15px;
		margin-right: 20px;
	}
	.mytable .info>div{
		height: 100%;
		display: flex;
		align-items: center;
	}
	.mytable .el-textarea__inner{
		color: red !important;
	}
</style>
